import { brl, num, imgUrl } from "@/lib/api";

export function OrderItems({ items }) {
  return (
    <ul className="divide-y divide-slate-100" data-testid="order-items">
      {items.map((it, i) => (
        <li key={i} className="flex items-center gap-4 py-3">
          <img src={imgUrl(it.image_url)} alt={it.name} className="h-14 w-14 rounded object-cover bg-slate-100" />
          <div className="flex-1 min-w-0">
            <p className="truncate font-semibold text-slate-900">{it.name}</p>
            <p className="text-xs text-slate-500">
              {it.pricing_type === "m2"
                ? `${num(it.height, 1)} cm (alt.) × ${num(it.width, 1)} cm (larg.) = ${num(it.area, 4)} m²${(it.billed_area ?? it.billedArea ?? 0) > it.area ? ` (cobrado ${num(it.billed_area ?? it.billedArea, 2)} m² mínimo)` : ""} · ${it.quantity} peça(s)`
                : it.option ? `${it.option_label || "Opção"}: ${it.option} · pacote com ${it.quantity} ${it.unit_label || "unidade"}(s)` : `${it.quantity} ${it.unit_label || "unidade"}(s)`}
            </p>
          </div>
          <p className="font-mono font-bold text-slate-900">{brl(it.subtotal)}</p>
        </li>
      ))}
    </ul>
  );
}
